import React, { useState } from 'react'
import PartNumber from 'pu-react/components/PartNumber';
import Revision from 'pu-react/components/Revision'
import StencilFile from 'pu-react/components/StencilFile';
import LengthText from "pu-react/components/carriers/LengthText";
import WidthText from "pu-react/components/carriers/WidthText";
import PressureHolder from "pu-react/components/carriers/PressureHolder";
import PrintConfirmation from 'pu-react/components/PrintConfirmationRadio';
import SpecialInstruction from 'pu-react/components/SpecialInstruction'
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import RowSelected from 'pu-react/components/RowSelected';
import ColumnSelected from 'pu-react/components/ColumnSelected';
import CarrierThickness from 'pu-react/components/carriers/CarrierThickness';
import {
  partNumber as partNumberTooltip,
  revision as revisionTooltip,
  materialThickness as materialThicknessTooltip,
  stencilFile as stencilFileTooltip,
  carrierWidth as carrierWidthTooltip,
  carrierLength as carrierLengthTooltip,
  printConfirmation as printConfirmationTooltip,
  pressureHolder as pressureHolderTypeTooltip
} from '../data/Tooltips';


const Parameters = (props) => {
  const { parameters, validator } = props
  const [zipFile, setZipFile] = useState(parameters.filename)

  validator.purgeFields();

  const onChangeFile = (event) => {
    const file = event.target.files[0];
    setZipFile(file ? file.name : null);
  }
  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-6">
          <PartNumber {...props} tooltip={partNumberTooltip}>
            {validator.message(`Part Number`, parameters.part_number, 'required|min:3')}
          </PartNumber>
        </div>
        <div className="col-12 col-lg-6">
          <Revision {...props} label="Revision number" tooltip={revisionTooltip}>
            {validator.message(`Revision`, parameters.revision, 'required')}
          </Revision>
        </div>
        <div className="col-12 col-lg-6">
          <CarrierThickness {...props} tooltip={materialThicknessTooltip} />
        </div>
        <div className="col-12 col-lg-6">
          <StencilFile required {...props} onChange={onChangeFile} tooltip={stencilFileTooltip}>
            {validator.message(`Zip File`, zipFile, 'required')}
          </StencilFile>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-6">
              <WidthText {...props} tooltip={carrierWidthTooltip}>
                {validator.message(`Carrier Width`, parameters.carrier_width, 'required|numeric|min:0.1,num|max:20,num')}
              </WidthText>
            </div>
            <div className="col-6">
              <LengthText {...props} tooltip={carrierLengthTooltip}>
                {validator.message(`Carrier Length`, parameters.carrier_length, 'required|numeric|min:0.1,num|max:24,num')}
              </LengthText>
            </div>
          </div>
        </div>
        <div className="col-12">
          <PrintConfirmation {...props} tooltip={printConfirmationTooltip}>
            {validator.message(`Check plot confirmation`, parameters.print_confirmation, 'required')}
          </PrintConfirmation>
        </div>
        <div className="col-12 mb-2">
          <PressureHolder {...props} validator={validator} pressureHolderTypeTooltip={pressureHolderTypeTooltip} />
        </div>

        <div className="col-12">
          <SpecialInstruction {...props} />
          <ProductQuoteNumber {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
        </div>
      </div>
    </div>
  )
}

export default Parameters;
